"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortFlow = exports.shortAndVerifyFlow = exports.longFlow = exports.componentsMap = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Paragraph_1 = require("../paragraph/Paragraph");
const Spacer_1 = require("../spacer/Spacer");
const theme_1 = __importDefault(require("../styles/theme"));
const publish_1_svg_1 = __importDefault(require("../../../92b3b47/assets/images/publish/publish-1.svg"));
const publish_2_svg_1 = __importDefault(require("../../../92b3b47/assets/images/publish/publish-2.svg"));
const publish_3_svg_1 = __importDefault(require("../../../92b3b47/assets/images/publish/publish-3.svg"));
const publish_4_svg_1 = __importDefault(require("../../../92b3b47/assets/images/publish/publish-4.svg"));
const publish_5_svg_1 = __importDefault(require("../../../92b3b47/assets/images/publish/publish-5.svg"));
const publish_6_svg_1 = __importDefault(require("../../../92b3b47/assets/images/publish/publish-6.svg"));
const Heading_1 = require("../heading/Heading");
const RoutingContext_1 = require("../../../context/RoutingContext");
const HeaderImage = styled_1.default.img `
	/* Modal applies a 20px margin on top, left, right, so we have to hack fill that */
	position: relative;
	width: calc(100% + 40px);
	left: -20px;
	top: -20px;
	// Portal has the rule img { max-width: 100% }, this works around that
	max-width: unset !important;

	height: 140px;

	@media only screen and (min-width: 768px) {
		height: 200px;
	}

	background-color: ${({ tint }) => tint};
	margin-bottom: ${theme_1.default.layout.spacing.smaller};
`;
const IntroPage = () => (React.createElement(React.Fragment, null,
    React.createElement(HeaderImage, { src: publish_1_svg_1.default, tint: theme_1.default.colours.primary.tint }),
    React.createElement(Heading_1.HeadingSmall, null, "Your property is ready for review!"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "Before we can build listings on your selected channels we need to optimise your property information and maximise your booking potential."),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Paragraph_1.Paragraph, null, "Please read and accept the following key points before publishing your property.")));
const InfoPageOne = () => (React.createElement(React.Fragment, null,
    React.createElement(HeaderImage, { src: publish_2_svg_1.default, tint: theme_1.default.colours.success.tint }),
    React.createElement(Heading_1.HeadingSmall, null, "All bookings are accepted instantly"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "Allowing guests to book immediately increases bookings. Travelnest uses Instant Book to confirm all bookings."),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Heading_1.HeadingSmall, null, "Duplicate listings are not allowed"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "When you join Travelnest, you must abide by channel terms and conditions. Duplicate listings are not allowed - only one listing is allowed per channel. Please remove or sync any existing listings with Travelnest.")));
const InfoPageTwo = () => (React.createElement(React.Fragment, null,
    React.createElement(HeaderImage, { src: publish_3_svg_1.default, tint: theme_1.default.colours.error.tint }),
    React.createElement(Heading_1.HeadingSmall, null, "Keep your calendar up to date"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "Bookings from sources not managed by Travelnest (e.g. a listing you manage yourself), must be connected to your Travelnest calendar. This prevents double bookings."),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Heading_1.HeadingSmall, null, "Avoid double bookings"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "If you ask us to cancel a booking, this will incur channel fees which are passed to you. Cancellations also affect the performance of your property on channels, which reduces your ability to attract bookings.")));
const InfoPageThree = () => {
    const { baseUrl } = React.useContext(RoutingContext_1.RouterContext);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderImage, { src: publish_4_svg_1.default, tint: theme_1.default.colours.error.tint }),
        React.createElement(Heading_1.HeadingSmall, null, "Connect external listings"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null,
            "If you have listings outside Travelnest, it is essential that these are connected to your Travelnest calendar using our iCal sync.",
            ' ',
            React.createElement("strong", null, "Double bookings which arise as a result of a failure to set up iCal sync will incur cancellation fees.")),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(Heading_1.HeadingSmall, null, "Set up iCal sync"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null,
            "In the",
            ' ',
            React.createElement("a", { href: `${baseUrl}/tasks/availability` }, "Booking availability section"),
            ' ',
            "connect all external listings to your Travelnest calendar. iCal sync is found under Additional calendar features. Please get in touch if you need help.")));
};
const PublishPage = () => (React.createElement(React.Fragment, null,
    React.createElement(HeaderImage, { src: publish_5_svg_1.default, tint: theme_1.default.colours.primary.tint }),
    React.createElement(Heading_1.HeadingSmall, null, "Good to go!"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "When you select 'Publish now' you consent to us listing your property on your selected channels. You can update the information in your account at any time, just remember to publish your changes."),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Heading_1.HeadingSmall, null, "Need help?"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "Our expert team is on hand to help you. You can email us at owners@travelnest.com.")));
const FailedPage = () => (React.createElement(React.Fragment, null,
    React.createElement(HeaderImage, { src: publish_1_svg_1.default, tint: theme_1.default.colours.primary.tint }),
    React.createElement(Heading_1.HeadingSmall, null, "Something has gone wrong"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "We've been unable to publish your property"),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Paragraph_1.Paragraph, null, "This is most likely due to a connection issue. Try publishing your property again."),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Paragraph_1.Paragraph, null, "If this happens again, get in touch with our team who can help.")));
const ShortPage = () => (React.createElement(React.Fragment, null,
    React.createElement(HeaderImage, { src: publish_4_svg_1.default, tint: theme_1.default.palette.green.tint }),
    React.createElement(Heading_1.HeadingSmall, null, "Publish your property"),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Paragraph_1.Paragraph, null, "When you select 'Publish property now', we will send your property profile to your selected marketing channels. The listing process will begin, and your property updates will shortly be visible to guests and open for bookings."),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Paragraph_1.Paragraph, null, "You can make changes to your property profile at any time.")));
const VerificationPending = () => (React.createElement(React.Fragment, null,
    React.createElement(HeaderImage, { src: publish_6_svg_1.default, tint: theme_1.default.palette.green.tint }),
    React.createElement(Paragraph_1.Paragraph, null,
        "Thank you for adding your property. Before it can go live on the channels, we need to review your new listing, which can take ",
        React.createElement("strong", null, "up to 72 hours."),
        " We may contact you to confirm some details."),
    React.createElement(Spacer_1.Spacer, null),
    React.createElement(Paragraph_1.Paragraph, null,
        "Once verified, your listings can take ",
        React.createElement("strong", null, "up to 14 days"),
        " to be generated across the channels you have selected.")));
exports.componentsMap = {
    Intro: React.createElement(IntroPage, null),
    InfoOne: React.createElement(InfoPageOne, null),
    InfoTwo: React.createElement(InfoPageTwo, null),
    InfoThree: React.createElement(InfoPageThree, null),
    Publish: React.createElement(PublishPage, null),
    Failed: React.createElement(FailedPage, null),
    Short: React.createElement(ShortPage, null),
    VerificationPending: React.createElement(VerificationPending, null),
};
exports.longFlow = [
    exports.componentsMap.Intro,
    exports.componentsMap.InfoOne,
    exports.componentsMap.InfoTwo,
    exports.componentsMap.InfoThree,
    exports.componentsMap.Publish,
    exports.componentsMap.VerificationPending,
    exports.componentsMap.Failed
];
exports.shortAndVerifyFlow = [
    exports.componentsMap.Short,
    exports.componentsMap.VerificationPending,
    exports.componentsMap.Failed
];
exports.shortFlow = [
    exports.componentsMap.Short,
    exports.componentsMap.Failed
];
//# sourceMappingURL=PagesAndFlows.js.map